import { render, staticRenderFns } from "./TabelaAtendimentos.vue?vue&type=template&id=e305d664&scoped=true"
import script from "./TabelaAtendimentos.vue?vue&type=script&lang=js"
export * from "./TabelaAtendimentos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e305d664",
  null
  
)

export default component.exports